import React from 'react';

import TourWrapper from './TourWrapper';

const Tour = ({ systemFeatures }) => {
  return <TourWrapper systemFeatures={systemFeatures} />;
};

export default Tour;
